'use strict';

const { removeItem } = require('public/js/lib/local-storage');
const STORAGE_KEYS = require('public/js/lib/storage-keys');

/**
 * Apply the currently selected dealer (returned by any location-update endpoint via
 * `LocationController::buildSelectedDealerPayload()`) to every DOM surface that displays
 * the selected dealer. Add new per-surface updaters here as more parts of the page become
 * reactive to dealer changes (PDP pricing, contact form dropdown, etc.).
 *
 * @param {{ name?: string, interactiveGarageDealerCode?: string }|null|undefined} dealer
 */
function applySelectedDealerToDom(dealer) {
	if (!dealer?.name) {
		return;
	}
	updateFindDealerTrigger(dealer);
	invalidateSupplierCache();
}

function updateFindDealerTrigger(dealer) {
	// Match legacy dealer_selection_modal: name targets `.find-dealer-text` globally (not only under `.find-dealer-button`).
	rp$('.find-dealer-text').text(dealer.name);
	rp$('.find-dealer-button').attr('data-ig-dealer-code', dealer.interactiveGarageDealerCode ?? '');
}

/**
 * Drop the localStorage supplier cache so dealer_selection_modal's
 * `loadSelectedDealerOnPageLoad` can't repaint surfaces from stale data on the next load.
 */
function invalidateSupplierCache() {
	removeItem(STORAGE_KEYS.SUPPLIER_V1);
}

module.exports = {
	applySelectedDealerToDom,
	updateFindDealerTrigger,
};
